<template>
  <v-dialog v-model="show" width="700">
    <v-card>
      <v-card-title class="text-h5 grey lighten-2">
        Detail
      </v-card-title>

      <div style="text=align:center;margin-left:10%;padding:20px;">
        <table>
          <tr>
            <td>Date</td>
            <td>{{displayDateTime(detailData.date) }}</td>
          </tr>
          <tr>
            <td>Status</td>
            <td>{{ getStatus(detailData.status) }}</td>
          </tr>
          <tr v-show="detailData.type == 1">
            <td>Duration</td>
            <td>{{ secondsToHms(detailData.duration) }}</td>
          </tr>
          <tr>
            <td>Type</td>
            <td>By {{ detailData.type == 1 ? "Phone" : "Going" }}</td>
          </tr>
          <tr v-show="detailData.type == 2">
            <td>Signature</td>
            <td>
              <img
                class="materialboxed"
                :src="'data:image/png;base64, ' + detailData.signature"
                alt
                style="width:200px;height:200px;"
              />
            </td>
          </tr>
        </table>
      </div>

      <div
        class="row side_effect_container"
        v-show="detailData.status == 1"
        style="margin-left:10%;"
      >
        <h4>Side Effect</h4>
        <p style="margin-left:20px;">{{ detailData.low_side_effect }}</p>
        <!-- <p
          v-for="(item, index) in detailData.raw_low_side_effect"
          v-bind:key="item.id"
        >
          {{ index + 1 }} {{ item.name }}
        </p> -->
      </div>
      <div
        class="row side_effect_container"
        v-show="detailData.status == 1"
        style="margin-left:10%;"
      >
        <h4>Action</h4>
        <p style="margin-left:90px;">{{ detailData.high_side_effect }}</p>
        <!-- <p
          v-for="(item, index) in detailData.raw_high_side_effect"
          v-bind:key="item.id"
        >
          {{ index + 1 }} {{ item.name }}
        </p> -->
      </div>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" text @click="show = false">
          Cancel
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  props: ["show", "detailData"],
  data() {
    return {
      //   dialog: false,
    };
  },
  methods: {
    getStatus(id) {
      switch (parseInt(id)) {
        case 1:
          return "Visted";

        case 2:
          return "Cannot call";

        case 0:
          return "Pending";
      }
    },
    secondsToHms(d) {
      d = Number(d);
      var h = Math.floor(d / 3600);
      var m = Math.floor((d % 3600) / 60);
      var s = Math.floor((d % 3600) % 60);
      var hDisplay = h > 0 ? h + (h == 1 ? " hour, " : " hours, ") : "";
      var mDisplay = m > 0 ? m + (m == 1 ? " minute, " : " minutes, ") : "";
      var sDisplay = s > 0 ? s + (s == 1 ? " second" : " seconds") : "";
      return hDisplay + mDisplay + sDisplay;
    },
    displayDateTime(v){
      const date = new Date(v);
      const current_date = date.getFullYear()+"-"+(date.getMonth()+1)+"-"+ date.getDate();
      const current_time = date.getHours()+":"+date.getMinutes()+":"+ date.getSeconds();
      return current_date +" "+current_time;
    }
  },
};
</script>
<style scoped>
.side_effect_container {
  padding: 20px;
}
</style>
